import * as constant from './constant'

/**
 * 根据优惠券类型获取对应的样式class
 * @param {number} type - 优惠券类型
 * @returns {string} 样式class名称
 */
export const getClassByCouponType = (type) => {
  let name = ''
  if (type === 1 || type === 11) {
    name = 'couponTypeOne'
  } else if (type === 2 || type === 12) {
    name = 'couponTypeTwo'
  } else if (type === 3 || type === 13) {
    return 'couponTypeThree'
  } else {
    name = 'couponTypeFour'
  }
  return name
}

/**
 * 根据优惠券类型获取对应的name
 * @param {number} type - 优惠券类型
 * @returns {string} 优惠券类型名称
 */
export const getNameByCouponType = (type) => {
  let name = ''
  switch (type) {
    case 1:
      name = '金额减免券(券面)'
      break
    case 2:
      name = '时长减免券(券面)'
      break
    case 3:
      name = '折扣减免券(券面)'
      break
    case 4:
      name = '全免券'
      break
    case 11:
      name = '金额减免券'
      break
    case 12:
      name = '时长减免券'
      break
    case 13:
      name = '折扣减免券'
      break
    default:
  }
  return name
}

/**
 * 根据优惠券类型获取对应的单位
 * @param {number} type - 优惠券类型
 * @returns {string} 单位名称
 */
export const getUnitByCouponType = (type) => {
  let name = ''
  if (type === 1 || type === 11) {
    name = '元'
  } else if (type === 2 || type === 12) {
    name = '分钟'
  } else if (type === 3 || type === 13) {
    return '折'
  } else {
    name = '张'
  }
  return name
}

/**
 * 获取优惠券名称
 * @param {number} type - 优惠券类型
 * @returns {string} 优惠券名称
 */
export const getCouponName = (type) => {
  let name = ''
  const couponTypeArray = constant.couponTypeArray
  for (let x = 0; x < couponTypeArray.length; x++) {
    if (type === couponTypeArray[x].type) {
      name = couponTypeArray[x].couponName
    }
  }
  return name
}

/**
 * 获取优惠券状态名称
 * @param {number} type - 优惠券状态类型
 * @returns {string} 优惠券状态名称
 */
export const getCouponStatusName = (type) => {
  let name = ''
  const couponStatusList = constant.couponStatusList
  for (let x = 0; x < couponStatusList.length; x++) {
    if (type === couponStatusList[x].type) {
      name = couponStatusList[x].typeName
    }
  }
  return name
}

/**
 * 根据优惠券名称获取对应的Value
 * @param {string} para - 优惠券名称
 * @returns {number} 优惠券类型值
 */
export const getCouponValByname = (para) => {
  let name = ''
  const couponTypeArray = constant.couponTypeArray
  for (let x = 0; x < couponTypeArray.length; x++) {
    if (para === couponTypeArray[x].couponName) {
      name = couponTypeArray[x].type
    }
  }
  return name
}

/**
 * 根据优惠券状态名称获取对应的Value
 * @param {string} para - 优惠券状态名称
 * @returns {number} 优惠券状态类型值
 */
export const getCouponStatusValByname = (para) => {
  let name = ''
  const couponStatusList = constant.couponStatusList
  for (let x = 0; x < couponStatusList.length; x++) {
    if (para === couponStatusList[x].typeName) {
      name = couponStatusList[x].type
    }
  }
  return name
}
